module.exports = __webpack_public_path__ + "img/stand height.4b2a3764.png";